import badge from "./badge.recipe";
import button from "./button.recipe";
import heading from "./heading.recipe";
import input from "./input.recipe";
import separator from "./separator.recipe";

export const recipes = {
  button,
  badge,
  heading,
  input,
  separator,
};
